import { PromotionCodeInfo } from './PromotionCodeInfo'
import { withPromotionCodeInfo } from './withPromotionCodeInfo'

const ConnectedPromotionCodeInfo = withPromotionCodeInfo(PromotionCodeInfo)

export { ConnectedPromotionCodeInfo as PromotionCodeInfo }
